import api from "../axios-cmk";
import moment from 'moment'
import {store} from "../store/helpers";

const get_headers = () => {
    return {
        headers: {
            Authorization: 'JWT ' + store.getState().auth.token
        }
    }
};


export function loadTherapists() {
    return api.get('therapists.json', get_headers())
}

export function loadVisitsInDate(date) {
    const formatted_date = moment(date).format('YYYY-MM-DD')
    return api.get('therapy_map.json?date=' + formatted_date, get_headers())
}

export function addTherapy(therapyData) {
    return api.post('/therapies.json', therapyData, get_headers());
}

export function cancelTherapy(id, paid, permanent) {
    if (permanent === true) {
        return api.get('/therapy_terms/' + id + '/delete/', get_headers())
    }
    return api.get('/therapy_terms/' + id + '/cancel' + (paid ? '' : '_free') + '/', get_headers())
}

export function updateTherapy(id, therapyData) {
    return api.patch('/therapy_terms/' + id + '/', therapyData, get_headers());
}

export function InvalidCredentialsException(message) {
    this.message = message;
    this.name = 'InvalidCredentialsException';
}


export function findPatients(query) {
    return api.get('patients_search.json/?q=' + query, get_headers())
}

export function loadPatient(id) {
    return api.get('patients_search/?pk=' + parseInt(id, 10), get_headers())
}

export function loadPatientDetails(id) {
    return api.get('patients/' + id + '/', get_headers())
}

export function updatePatient(id, patientData) {
    return api.patch('/patients/' + id + '/', patientData, get_headers());
}

export function patientsReport(month) {
    return api.get('/patient_reports.json?period=' + month, get_headers());
}

export function visitsReport(month) {
    return api.get('/reports.json?period=' + month, get_headers());
}

export function massActionOnVisits(actionName, visit_ids) {
    const action_data = {'visits': visit_ids, 'action_name': actionName};
    return api.post('/therapy_terms/mass_action/', action_data, get_headers());
}


// WEBPACK FOOTER //
// ./src/api/CMKApi.js